export class Service1 {
  constructor() {
    this._services = document.querySelectorAll('.s-services1');

    if (this._services.length) {
      this._init();
    }
  }

  _init() {
    this._services.forEach(section => {
      let services = section.querySelectorAll('.service');

      services.forEach(service => {
        let container = service.querySelector('.service-content');
        let content = service.querySelector('.service-content p');
        let height = content.offsetHeight;

        container.style.transform = `translateY(${height}px)`;
        content.style.opacity = '0';
      })
    })
  }
}
